import { SsoSettings } from "@/domain/common/Sso";

export const isFetching = (state: any ) => {
    return state.isFetching
}

export const allSso = (state: any) => {
    return state.Sso
}